import { DeckCardData } from './types';
import ActivityDeckCard from './ActivityDeckCard';
import SponsoredDeckCard from './SponsoredDeckCard';
import SkeletonDeckCard from './SkeletonDeckCard';
import PlaceholderDeckCard from './PlaceholderDeckCard';
import IntroCardDeckCard from './IntroCardDeckCard';
import JourneyCardDeckCard from './JourneyCardDeckCard';

interface DeckCardProps {
  card: DeckCardData;
}

/**
 * DeckCard Component
 *
 * Router component that renders the appropriate card type
 * based on the card data's `type` property.
 */
export default function DeckCard({ card }: DeckCardProps) {
  switch (card.type) {
    case 'activity':
      return <ActivityDeckCard card={card} />;
    case 'sponsored':
      return <SponsoredDeckCard card={card} />;
    case 'skeleton':
      return <SkeletonDeckCard />;
    case 'placeholder':
      return <PlaceholderDeckCard />;
    case 'intro':
      return <IntroCardDeckCard />;
    case 'journey':
      return <JourneyCardDeckCard />;
    default:
      return <ActivityDeckCard card={card} />;
  }
}
